const getFormattedDate = (date) => {
    let weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    
    let day = weekDays[date.getDay()];
    let month = months[date.getMonth()];
    
    let dayWithSuffix = date.getDate() + (
        date.getDate() % 10 === 1 && date.getDate() !== 11 ? 'st' : 
        date.getDate() % 10 === 2 && date.getDate() !== 12 ? 'nd' :
        date.getDate() % 10 === 3 && date.getDate() !== 13 ? 'rd' : 'th'
    );
    
    return `${day} ${dayWithSuffix} ${month}`;
}

const formatMoney = (amount) => {
    // if string, convert to number
    if (typeof amount === 'string') {
        amount = parseFloat(amount);
    }
    
    // add .00 to the end of the amount if it's a whole number
    if (amount % 1 === 0) {
        amount += '.00';
    }
    return window.languages.shopMoneyFormat.replace('{{amount}}', amount);
}

const formatMoneyHtml = (amount) => {
    // add .00 to the end of the amount if it's a whole number
    amount = Math.abs(amount);
    
    if (amount % 1 === 0) {
        amount += '.00';
    }
    let formatted = window.languages.shopMoneyFormat.replace('{{amount}}', amount).split('.');
    let priceDecimals = formatted[1];
    
    return `<span class="subtotal-lower">${formatted[0].slice(0, 1)}</span><span class="subtotal-upper">${formatted[0].slice(1)}</span>${priceDecimals ? `<span class="subtotal-lower">.${priceDecimals}</span>` : ''}`;
}

const formatMoneyHtmlLowerCurrency = (amount, noTrailingZeros) => {
    if (typeof amount === 'string') {
        amount = parseFloat(amount);
    }
    
    // add .00 to the end of the amount if it's a whole number
    amount = Math.abs(amount);
    if (amount % 1 === 0) {
        amount += '.00';
    }

    if (noTrailingZeros) {
        amount = amount.toString().replace('.00', '');
    }
    let formatted = window.languages.shopMoneyFormat.replace('{{amount}}', amount);
    
    return `<span class="subtotal-lower">${formatted.slice(0, 1)}</span><span class="subtotal-upper">${formatted.slice(1)}</span>`;
}

let currentWeekdayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

class CustomOrderEdit extends HTMLElement {
    isReorder = false;

    constructor() {
        super();
        this.orderEditButtons = document.querySelectorAll('.custom-modal__item[href="/?flow=edit"], .custom-modal__item[href="/pages/edit"]');
        this.reorderButtons = document.querySelectorAll('.custom-modal__item[href="/?flow=reorder"], .custom-modal__item[href="/pages/re-order"]');
        this.orderEditCTAs = document.querySelectorAll('.edit-order--cta');
        this.reorderCTAs = document.querySelectorAll('.duplicate-order--cta');
        
        this.orderEditLogin = document.querySelector('.edit-popup__login');
        this.orderEditDetails = document.querySelector('.edit-popup__order');
        this.orderReorderDetails = document.querySelector('.edit-popup__order--reorder');
        this.orderReorderUpsell = document.querySelector('.edit-popup__order--reorder-upsell');
        this.popupUpdatedOrder = document.querySelector('.edit-popup__updated-order');
        this.orderEditLinkPage = document.querySelector('.edit-popup__link');
        this.orderEditLinkSuccessPage = document.querySelector('.edit-popup__link--success');
        this.orderErrorPage = document.querySelector('.edit-popup__error');
        
        this.orderEditLoginButton = document.querySelector('.edit-popup__button--login');
        this.orderEditSubmitButton = document.querySelector('.edit-popup__button--update');
        this.orderEditClosePopup = document.querySelector('.edit-popup__close');
        this.orderEditClosePopupCTA = document.querySelector('.edit-popup__button--close');
        this.orderEditOverlay = document.querySelector('.edit-popup__overlay');

        this.emailLinkPrompt = document.querySelector('.edit-popup__button--link-prompt');
        this.emailLinksBack = document.querySelectorAll('.edit-popup__button--back');
        this.emailLink = document.querySelector('.edit-popup__link .edit-popup__button--link');
        this.errorLinkBack = document.querySelector('.edit-popup__error .edit-popup__button--back');
        
        this.orderGoBack = document.querySelector('.edit-popup__button--edit');
        
        this.popupTitleOrder = document.querySelector('.edit-popup__title');
        this.popupDescriptionOrder = document.querySelector('.edit-popup__description-order');
        this.loginDescription = document.querySelector('.edit-popup__description-login');
        this.loginDescriptionReorder = document.querySelector('.edit-popup__description--reorder');
        this.descriptionReorderUpsell = document.querySelector('.edit-popup__description--reorder-upsell');
        this.popupDescriptionOrderUpdated = document.querySelector('.edit-popup__description-updated');
        this.popupDescriptionLink = document.querySelector('.edit-popup__description-link');
        this.popupDescriptionLinkSuccess = document.querySelector('.edit-popup__description-link-success');
        this.popupDescriptionError = document.querySelector('.edit-popup__description-error');

        this.contactButtons = document.querySelectorAll('.edit-popup__button--contact');

        this.contactButtons.forEach(button => {
            button.addEventListener('click', () => {
                Intercom('showNewMessage');
            });
        });
        
        this.orderEditInputs = document.querySelectorAll('.edit-popup__order .edit-popup__input');
        
        this.orderEditClosePopup.addEventListener('click', this.handleClose.bind(this));
        this.orderEditClosePopupCTA.addEventListener('click', this.handleClose.bind(this));
        this.orderEditOverlay.addEventListener('click', this.handleClose.bind(this));

        this.orderGoBack.addEventListener('click', this.reopenEdit.bind(this));
        this.orderEditLoginButton.addEventListener('click', () => this.handleLogin());
        this.orderEditSubmitButton.addEventListener('click', this.handleOrderUpdate.bind(this));
        
        this.emailLinkPrompt.addEventListener('click', () => this.openLinkPage());
        this.emailLinksBack.forEach(link => {
            link.addEventListener('click', this.closeLinkPage.bind(this));
        });
        this.errorLinkBack.addEventListener('click', this.closeErrorPage.bind(this));
        this.emailLink.addEventListener('click', this.sendEmailLink.bind(this));
        
        this.orderEditInputs.forEach(input => {
            input.addEventListener('input', () => {
                this.orderEditSubmitButton.classList.remove('edit-popup__button--disabled');
                this.orderEditSubmitButton.removeAttribute('disabled');
                this.order[input.name] = input.value;
            });
        });
        
        let accordionItems = document.querySelectorAll('.edit-popup__card-header');
        accordionItems.forEach(item => {
            item.addEventListener('click', function() {
                let parent = item.closest('.edit-popup__card');
                parent.classList.toggle('edit-popup__card--active');
            });
        });

        this.orderEditButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                if (this.classList.contains('edit-popup--reorder')) {
                    this.classList.remove('edit-popup--reorder');
                    this.loginDescriptionReorder.classList.add('edit-popup--hidden');
                    this.loginDescription.classList.remove('edit-popup--hidden');
                    this.orderEditLogin.classList.remove('edit-popup--hidden');
                    this.orderReorderDetails.classList.add('edit-popup--hidden');
                    this.orderEditLoginButton.innerText = 'Update';
                    this.popupTitleOrder.innerText = 'Edit Order';
                    this.isReorder = false;
                }

                this.classList.toggle('edit-popup--active');
                
                return false;
            });
        });

        this.reorderButtons.forEach(button => {
            button.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();

                if (!this.isReorder) {
                    this.classList.add('edit-popup--reorder');
                    this.loginDescriptionReorder.classList.remove('edit-popup--hidden');
                    this.loginDescription.classList.add('edit-popup--hidden');
                    this.orderEditLogin.classList.remove('edit-popup--hidden');
                    this.popupTitleOrder.innerText = 'Reorder';
                    this.orderEditLoginButton.innerText = 'Reorder';
                    this.isReorder = true;
                }

                this.classList.add('edit-popup--active');

                return false;
            });
        });

        this.reorderContinueButton = document.querySelector('.edit-popup__button--reorder');
        this.reorderUpsellContinueButton = document.querySelector('.edit-popup__button--reorder-upsell');
        this.reorderBackButton = document.querySelector('.edit-popup__button--reorder-back');


        if (this.dataset.reorderUpsellsEnabled === 'true') {
            this.reorderContinueButton.addEventListener('click', async () => {

                if (!this.reorderDateSet) {
                    let dateError = this.orderReorderDetails.querySelector('.edit-popup__input-wrapper--zapiet .edit-popup__input-error');
                    dateError.classList.add('edit-popup__input-error--active');
                    return;
                }
                
                this.popupTitleOrder.innerText = 'Add To Your Order & Save';
                this.orderReorderDetails.classList.add('edit-popup--hidden');
                this.orderReorderUpsell.classList.remove('edit-popup--hidden');
                this.loginDescriptionReorder.classList.add('edit-popup--hidden');
                this.descriptionReorderUpsell.classList.remove('edit-popup--hidden');
            });
        } else {
            this.reorderUpsellContinueButton = this.reorderContinueButton;
        }
        
        this.reorderBackButton.addEventListener('click', async () => {
            this.orderReorderDetails.classList.remove('edit-popup--hidden');
            this.orderReorderUpsell.classList.add('edit-popup--hidden');
            this.loginDescriptionReorder.classList.remove('edit-popup--hidden');
            this.descriptionReorderUpsell.classList.add('edit-popup--hidden');
        });


        this.reorderUpsellContinueButton.addEventListener('click', async () => {
            let itemUpdates = this.order.lineItems.filter(item => !item.upsellNew);
            let formData = {
                'updates': itemUpdates.reduce((acc, item) => {
                    acc[item.variant.id.replace('gid://shopify/ProductVariant/', '')] = item.currentQuantity;
                    return acc;
                }, {}),
                'attributes': this.order.customAttributes.reduce((acc, attr) => {
                    acc[attr.key] = attr.value;
                    return acc;
                }, {})
            };

            let newItems = this.order.lineItems.filter(item => item.upsellNew);
            await fetch('/cart/clear.js', {
                method: 'POST',
            });
            
            let resp = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            }).then(response => response.json())
            
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: newItems.map(item => {
                        return {
                            id: item.variant.id,
                            quantity: item.currentQuantity
                        }
                    })
                })
            }).then(response => response.json())

            window.location.href = '/checkout';
        });


        this.customSelect = document.querySelector('.edit-popup__input--select');
        this.customSelectButton = document.querySelector('.edit-popup__select-button');
        
        this.invisibleSelect = this.customSelect.parentNode.parentNode.querySelector('select');
        this.customSelectOptions = this.customSelect.querySelectorAll('option');

        this.orderEditCTAs.forEach(cta => {
            cta.addEventListener('click', async () => {
                if (this.classList.contains('edit-popup--reorder')) {
                    this.classList.remove('edit-popup--reorder');
                    this.loginDescriptionReorder.classList.add('edit-popup--hidden');
                    this.loginDescription.classList.remove('edit-popup--hidden');
                    this.orderEditLogin.classList.add('edit-popup--hidden');
                    this.orderEditLoginButton.innerText = 'Update';
                    this.popupTitleOrder.innerText = 'Edit Order';
                    this.isReorder = false;
                }

                let orderId = cta.dataset.order;
                await this.handleLogin(false, false, orderId)
                this.classList.add('edit-popup--active');
            });
        });


        this.init();
        
    }
    
    async init () {
        // Backward compatibility: redirect old page-based URLs to new query parameter format
        // Only redirect if we're actually on those pages (not just on homepage with the component)
        const currentPath = window.location.pathname;

        if (currentPath === '/pages/edit') {
            const params = new URLSearchParams(window.location.search);
            params.set('flow', 'edit');
            window.location.replace('/?' + params.toString());
            return;
        }

        if (currentPath === '/pages/re-order') {
            const params = new URLSearchParams(window.location.search);
            params.set('flow', 'reorder');
            window.location.replace('/?' + params.toString());
            return;
        }

        this.customSelectButton.addEventListener('click', this.selectClickHandler.bind(this));

        this.customSelectOptions.forEach(option => {
            let newOption = document.createElement('li');
            newOption.innerText = option.innerText;
            newOption.dataset.value = option.value;
            newOption.classList.add('edit-popup__input--select-option');
            this.customSelect.appendChild(newOption);
            option.remove();

            newOption.addEventListener('click', this.handleOptionClick.bind(this));
        });

        let params = new URLSearchParams(window.location.search);

        if (params.get('flow') === 'edit' || params.has('edit')) {
            let orderNumber = params.get('orderNumber');
            let details = params.get('details') || params.get('email') || params.get('phone');

            if (orderNumber && details) {
                await this.handleLogin(details, orderNumber);
                this.classList.add('edit-popup--active');
            }
        }

        if (params.get('flow') === 'reorder' || params.has('reorder')) {
            let contact = params.get('contact');

            if (contact) {
                this.isReorder = true;
                await this.handleLogin(contact, false, false);
                this.loginDescriptionReorder.classList.remove('edit-popup--hidden');
                this.popupTitleOrder.innerText = 'Reorder';
                this.classList.add('edit-popup--active');
                this.classList.add('edit-popup--reorder');
            }
        }
    }

    async getAvailableDates () {
        let locationId = ((this.order.customAttributes.find(attr => attr.key === 'Delivery-Location-Id') || {}).value || '').replace('/', '-');

        if (!locationId) {
            let locationIdResponse = await fetch(`https://api-us.zapiet.com/v1.0/delivery/locations?shop=billy-bubbles-au.myshopify.com`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    geoSearchQuery: this.order.shippingAddress.zip
                })
            });
            let locationIdData = await locationIdResponse.json();
            locationId = locationIdData.id;

            if (!locationId) {
                return {
                    disabled: [],
                    slots: []
                };
            }
            
            this.order.customAttributes.push({
                key: 'Delivery-Location-Id',
                value: locationId
            });
        }

        let availableSlotsResponse = await fetch(`https://api-us.zapiet.com/v1.0/delivery/locations/${locationId}/calendar?shop=billy-bubbles-au.myshopify.com`);
        let availableSlots = await availableSlotsResponse.json();

        console.log('📡 API Response from getAvailableDates:', {
            locationId,
            fullResponse: availableSlots,
            disabledDates: availableSlots.disabled,
            slots: availableSlots.slots
        });

        if (!availableSlots.slots && availableSlots.error == 'METHOD_NOT_ENABLED') {
            let locationIdResponse = await fetch(`https://api-us.zapiet.com/v1.0/delivery/locations?shop=billy-bubbles-au.myshopify.com`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    geoSearchQuery: this.order.shippingAddress.zip
                })
            });
            let locationIdData = await locationIdResponse.json();
            locationId = locationIdData.id;

            availableSlotsResponse = await fetch(`https://api-us.zapiet.com/v1.0/delivery/locations/${locationId}/calendar?shop=billy-bubbles-au.myshopify.com`);
            availableSlots = await availableSlotsResponse.json();

            console.log('📡 API Response from getAvailableDates (after retry):', {
                locationId,
                fullResponse: availableSlots,
                disabledDates: availableSlots.disabled,
                slots: availableSlots.slots
            });

            return availableSlots;
        }

        return availableSlots;
    }

    async getAvailableTimes (date) {
        let locationId = (`${(this.order.customAttributes.find(attr => attr.key === 'Delivery-Location-Id') || {}).value}` || '').replace('/', '-');

        if (!locationId) {
            return [];
        }

        let availableTimesResponse = await fetch(`https://api-us.zapiet.com/v1.0/delivery/locations/${locationId}/calendar/${date}?shop=billy-bubbles-au.myshopify.com`);
        let availableTimes = await availableTimesResponse.json();

        if (!availableTimes.slots && availableTimes.error == 'METHOD_NOT_ENABLED') {
            let locationIdResponse = await fetch(`https://api-us.zapiet.com/v1.0/delivery/locations?shop=billy-bubbles-au.myshopify.com`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    geoSearchQuery: this.order.shippingAddress.zip
                })
            });
            let locationIdData = await locationIdResponse.json();
            locationId = locationIdData.id;

            let availableTimesResponse = await fetch(`https://api-us.zapiet.com/v1.0/delivery/locations/${locationId}/calendar/${date}?shop=billy-bubbles-au.myshopify.com`);
            let availableTimes = await availableTimesResponse.json();

            return availableTimes;
        }
            

        return availableTimes;
    }

    calendarSetup (el) {
        this.customZapietInputContainer = el.querySelector('.edit-popup__input-wrapper--zapiet');
        this.customZapietInput = this.customZapietInputContainer.querySelector('input');

        this.customZapietInputCalendar = this.customZapietInputContainer.querySelector('.picker');
        this.customZapietInputCalendarDays = this.customZapietInputCalendar.querySelector('tbody');
        this.customZapietInputCalendarMonth = this.customZapietInputCalendar.querySelector('.picker__month');
        this.customZapietInputCalendarYear = this.customZapietInputCalendar.querySelector('.picker__year');

        this.customZapietInputTimes = this.customZapietInputContainer.querySelector('.picker__list.picker__list--time');


        this.calendarPrevious = this.customZapietInputContainer.querySelector('.picker__nav--prev');
        this.calendarNext = this.customZapietInputContainer.querySelector('.picker__nav--next');

        this.calendarPrevious.addEventListener('click', this.previousMonth.bind(this));
        this.calendarNext.addEventListener('click', this.nextMonth.bind(this));

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.picker') && !e.target.closest('.edit-popup__input-wrapper--zapiet')) {
                this.customZapietInputCalendar.classList.remove('picker--opened');
            } 
            
            if (e.target.classList.contains('edit-popup__input') && e.target.closest('.edit-popup__input-wrapper--zapiet')) {
                this.customZapietInputCalendar.classList.add('picker--opened');
            }
        });
    }

    previousMonth () {
        let currentMonth = this.date.getMonth();
        let newMonth = currentMonth - 1;
        let newYear = this.date.getFullYear();
        
        if (newMonth < 0) {
            newMonth = 11;
            newYear--;
        } 

        this.date = new Date(newYear, newMonth);
        this.renderMonth();
    }

    nextMonth () {
        let currentMonth = this.date.getMonth();
        let newMonth = currentMonth + 1;
        let newYear = this.date.getFullYear();

        if (newMonth > 11) {
            newMonth = 0;
            newYear++;
        }

        this.date = new Date(newYear, newMonth);
        this.renderMonth();
    }

    async renderMonth () {
        let now = this.date;

        const totalSquares = 35;
        let totalSquaresArray = Array.from({ length: totalSquares });

        let availableDates = await this.getAvailableDates();

        console.log('🗓️ Available Dates Data:', availableDates);
        console.log('📅 Disabled Dates Array:', availableDates.disabled);

        // Get the number of days in the current month
        const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();

        // Get the day of the week the month starts on, check offset from Sunday
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        const monthStartWeekday = monthStart.getDay();

        let slotsFound = [];
        let currentRow = 0;

        let newCalendarDaysHtml = '';

        let startingDate = new Date(Date.parse(availableDates.minDate))

        totalSquaresArray.map((_, index) => {
            let classes = 'picker__day';
            let day = index + 1 - monthStartWeekday
            
            let date = new Date(now.getFullYear(), now.getMonth(), day);

            let currentWeekday = date.getDay();
            let currentWeekdayName = currentWeekdayNames[currentWeekday];
            let isEmpty = index < monthStartWeekday || index >= daysInMonth + monthStartWeekday;

            let isAvailable = false;

            let isSlot = !!availableDates.slots.find(slot => {
                let isWeekday = slot.day_of_week === currentWeekdayName;
                let isDate = date > startingDate;
                return isWeekday && isDate;
            });

            // Specific logging for Feb 27
            if (day === 27 && now.getMonth() === 1) {
                console.log(`🔍 Processing Feb 27:`, {
                    date: date.toDateString(),
                    dateString: date.toDateString(),
                    currentWeekdayName,
                    isSlot,
                    isEmpty
                });
            }

            if (isSlot) {
                isAvailable = true;
            }

            availableDates.disabled.forEach(disabledDateObject => {
                let year = disabledDateObject[0];
                let month = disabledDateObject[1]; // API uses 0-indexed months (Jan=0, Feb=1), same as JS Date
                let day = disabledDateObject[2];

                let disabledDate = new Date(year, month, day);

                // Debug logging for Feb 27 (month 1 = February in 0-indexed)
                if (day === 27 && month === 1) {
                    console.log(`🔎 Checking Feb 27 in disabled array:`, {
                        disabledDateObject,
                        apiMonth: disabledDateObject[1],
                        jsMonth: month,
                        constructedDate: disabledDate.toDateString(),
                        currentDateBeingChecked: date.toDateString(),
                        matches: date.toDateString() === disabledDate.toDateString()
                    });
                }

                if (date.toDateString() === disabledDate.toDateString()) {
                    isAvailable = false;
                    console.log(`❌ DISABLED DATE MATCHED: ${date.toDateString()} (${year}-${disabledDateObject[1]}-${disabledDateObject[2]})`, {
                        currentDate: date.toDateString(),
                        disabledDate: disabledDate.toDateString(),
                        isAvailable,
                        isSlot
                    });
                }
            });

            if (index == currentRow * 7) {
                newCalendarDaysHtml += `<tr>`;
            }

            if (isEmpty) {
                classes += ' picker__day--empty';
            }

            if (!isAvailable) {
                classes += ' picker__day--disabled';
                console.log(`🚫 Adding disabled class to: ${date.toDateString()}`, {
                    isAvailable,
                    isSlot,
                    isEmpty,
                    finalClasses: classes
                });
            }

            newCalendarDaysHtml += `
                <td role="presentation">
                    <div class="${classes}" role="gridcell" data-time="${date.getTime()}" aria-label="${date.toDateString()}" aria-disabled="true">
                        ${!isEmpty ? day : ''}
                    </div>
                </td>
            `;

            if (index == currentRow * 7 + 6) {
                newCalendarDaysHtml += `</tr>`;
                currentRow++;
            }
        });

        this.customZapietInputCalendarDays.innerHTML = newCalendarDaysHtml;

        let availableDateSlots = this.customZapietInputCalendarDays.querySelectorAll('.picker__day:not(.picker__day--empty):not(.picker__day--disabled)');
        availableDateSlots.forEach(slot => {
            slot.addEventListener('click', this.selectDate.bind(this));
        });

        this.customZapietInputCalendarMonth.innerText = now.toLocaleString('default', { month: 'long' });
        this.customZapietInputCalendarYear.innerText = now.getFullYear();
    }

    selectDate (e) {
        let selectedDateTime = e.target.getAttribute('data-time');
        let selectedDate = new Date(parseInt(selectedDateTime));

        let month = selectedDate.getMonth() + 1;
        if (month < 10) {
            month = `0${month}`;
        }

        let day = selectedDate.getDate();
        if (day < 10) {
            day = `0${day}`;
        }

        let selectedDateFormatted = `${selectedDate.getFullYear()}-${month}-${day}`;
        let dateAttributeIndex = this.order.customAttributes.findIndex(attr => attr.key === 'Delivery-Date');

        if (dateAttributeIndex > -1) {
            this.order.customAttributes[dateAttributeIndex].value = selectedDateFormatted.replaceAll('-', '/');
        } else {
            this.order.customAttributes.push({
                key: 'Delivery-Date',
                value: selectedDateFormatted.replaceAll('-', '/')
            });
        }

        this.customZapietInput.value = getFormattedDate(selectedDate);
        this.customZapietInput.dataset.date =  selectedDateFormatted;
        this.customZapietInputCalendar.classList.remove('picker--opened');
        this.renderDateSlots();
    }

    async renderDateSlots () {
        let availableTimes = await this.getAvailableTimes(this.customZapietInput.dataset.date);

        let availableTimesHtml = '';

        availableTimes.map(time => {
            availableTimesHtml += `
                <li 
                    class="picker__list-item" 
                    role="option" 
                    aria-label="${time.available_from}"
                >
                    <span class="from">${time.available_from}</span>
                    <span class="joiner">-</span>
                    <span class="to">${time.available_until}</span>
                </li>
            `;
        });

        this.customZapietInputTimes.innerHTML = availableTimesHtml;

        let availableTimeSlots = this.customZapietInputTimes.querySelectorAll('.picker__list-item');
        availableTimeSlots.forEach(slot => {
            slot.addEventListener('click', this.selectTime.bind(this));
        });
        this.customZapietInputTimes.classList.add('picker--opened');
    }

    selectTime (e) {
        let selectedTime = e.target.closest('.picker__list-item').innerText;
        let timeAttributeIndex = this.order.customAttributes.findIndex(attr => attr.key === 'Delivery-Time');

        if (timeAttributeIndex > -1) {
            this.order.customAttributes[timeAttributeIndex].value = selectedTime;
        } else {
            this.order.customAttributes.push({
                key: 'Delivery-Time',
                value: selectedTime
            });
        }

        this.customZapietInputTimes.classList.remove('picker--opened');
        this.customZapietInput.value = `${this.customZapietInput.value} ${selectedTime}`;

        if (!this.isReorder) {
            this.handleOrderChange();
        } else {
            this.handleReorderChange();
            this.reorderDateSet = true;
        }
    }

    async sendEmailLink () {
        this.emailLink.classList.add('edit-popup__button--loading');
        let email = this.orderEditLinkPage.querySelector('.edit-popup__input[name="contact"]').value;
        let emailResponse = await fetch('https://billybubbles.com/apps/order-api', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email,
                type: 'email'
            })
        });
        let emailBody = await emailResponse.json();

        if (emailBody.error) {
            this.emailLink.classList.remove('edit-popup__button--loading');
            alert(emailBody.error);
            return;
        }

        if (emailBody.success) {
            this.emailLink.classList.remove('edit-popup__button--loading');
            this.orderEditLinkPage.classList.add('edit-popup--hidden');
            this.orderEditLinkSuccessPage.classList.remove('edit-popup--hidden');
            
            this.popupDescriptionLink.classList.add('edit-popup--hidden');
            this.popupDescriptionLinkSuccess.classList.remove('edit-popup--hidden');

            this.popupTitleOrder.innerText = 'Order Number Incoming';
        }

        this.emailLink.classList.remove('edit-popup__button--loading');
    }
    
    openLinkPage (titleContent = 'Find Your Order') {
        this.orderEditLinkPage.classList.remove('edit-popup--hidden');
        this.orderEditLogin.classList.add('edit-popup--hidden');
        
        this.popupDescriptionLink.classList.remove('edit-popup--hidden');
        this.loginDescription.classList.add('edit-popup--hidden');
        
        this.popupTitleOrder.innerText = titleContent
    }
    
    closeLinkPage () {
        console.log('closing link page');
        
        this.orderEditLinkPage.classList.add('edit-popup--hidden');
        this.orderEditLinkSuccessPage.classList.add('edit-popup--hidden');
        this.orderEditLogin.classList.remove('edit-popup--hidden');

        this.popupDescriptionLinkSuccess.classList.add('edit-popup--hidden');
        this.popupDescriptionLink.classList.add('edit-popup--hidden');

        this.loginDescription.classList.remove('edit-popup--hidden');
        
        this.popupTitleOrder.innerText = 'Edit Order';
    }
    
    reopenEdit () {
        this.popupDescriptionOrder.classList.remove('edit-popup--hidden');
        this.popupDescriptionOrderUpdated.classList.add('edit-popup--hidden');
        this.orderEditDetails.classList.remove('edit-popup--hidden');
        this.popupUpdatedOrder.classList.add('edit-popup--hidden');
    }
    
    selectClickHandler (e) {
        e.stopPropagation();
        e.preventDefault();
        this.customSelect.classList.toggle('edit-popup__input--select-active');
        this.customSelectButton.classList.toggle('edit-popup__select-button--active');
        return false;
    }
    
    handleOptionClick (e) {
        this.customSelectOptions.forEach(option => {
            option.classList.remove('edit-popup__input--select-active');
        });
        option.classList.add('edit-popup__input--select-active');
        
        this.customSelect.querySelector('span').innerText = option.innerText;
        this.customSelect.classList.remove('edit-popup__input--select-active');
        this.invisibleSelect.value = option.value;
    }
    
    openErrorPage (errorTitle, errorDescription) {
        this.orderErrorPage.classList.remove('edit-popup--hidden');
        this.orderEditLogin.classList.add('edit-popup--hidden');
        
        this.popupDescriptionError.classList.remove('edit-popup--hidden');
        this.loginDescription.classList.add('edit-popup--hidden');
        
        this.popupTitleOrder.innerText = errorTitle;
        this.popupDescriptionError.innerText = errorDescription;
    }   
    
    closeErrorPage () {
        this.orderErrorPage.classList.add('edit-popup--hidden');
        this.orderEditLogin.classList.remove('edit-popup--hidden');
        
        this.popupDescriptionError.classList.add('edit-popup--hidden');
        this.loginDescription.classList.remove('edit-popup--hidden');
        
        this.popupTitleOrder.innerText = 'Edit Order';
    }
    
    async handleLogin (overrideContact = false, overrideOrderNumber = false, orderId = false) {
        let loginParent = this.orderEditLoginButton.closest('.edit-popup__login');
        let contactInput = loginParent.querySelector('.edit-popup__input[name="contact"]');
        let orderNumberInput = loginParent.querySelector('.edit-popup__input[name="orderNumber"]');
        let errorsFound = false;


        if (!this.isReorder) {
            if (!orderNumberInput.value && !overrideOrderNumber && !orderId) {
                let orderNumberError = orderNumberInput.parentNode.querySelector('.edit-popup__input-error');
                orderNumberError.classList.add('edit-popup__input-error--active');
                orderNumberInput.classList.add('edit-popup__input--error');
                errorsFound = true;
            }
        }
        
        if (!contactInput.value && !overrideContact && !orderId) {
            let contactError = contactInput.parentNode.querySelector('.edit-popup__input-error');
            contactError.classList.add('edit-popup__input-error--active');
            contactInput.classList.add('edit-popup__input--error');
            errorsFound = true;
        } 
        
        if (errorsFound) {
            return;
        }

        // check if contact is phone number, if it has international code
        // if not, add +61 to the start of the number
        let contactInputValue = contactInput.value;
        let hasPhone = contactInputValue.match(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
        if (hasPhone) {
            let phone = hasPhone.join('');

            if (phone[0] === '6') {
                contactInputValue = `+${phone}`;
            }

            if (phone[0] === '0') {
                contactInputValue = `+61${phone.slice(1)}`;
            }

            contactInputValue = contactInputValue.replaceAll(/ /g,'')
        }

        this.orderEditLoginButton.classList.add('edit-popup__button--loading');
        let orderFound = await fetch('https://billybubbles.com/apps/order-api', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                contact: overrideContact || contactInputValue,
                orderNumber: overrideOrderNumber || orderNumberInput.value,
                orderId: orderId || false,
                isReorder: this.isReorder,
                type: 'get'
            })
        })
        
        orderFound = await orderFound.json();
        
        if (orderFound.error) {
            switch (orderFound.error) {
                case 'NO_ORDER':
                    this.openLinkPage('Order Not Found');
                break;
                case 'CONTACT':
                case 'NO_CUSTOMER':
                    let contactError = contactInput.parentNode.querySelector('.edit-popup__input-error');
                    contactError.classList.add('edit-popup__input-error--active');
                    contactInput.classList.add('edit-popup__input--error');
                break;
                case 'CLOSED':
                    this.openErrorPage('Order Has Been Completed', 'This order has been completed, please check your order number and try again.');
                break;
            }
            this.orderEditLoginButton.classList.remove('edit-popup__button--loading');
            return;
        }
        
        this.order = orderFound.order;
        
        if (!this.isReorder) {

            let {
                email,
                phone,
                id,
                lineItems,
                note,
                shippingAddress,
                customer,
                customAttributes,
                name
            } = this.order;
            
            let {
                address1,
                address2,
                city,
                country,
                province,
                zip
            } = shippingAddress || {};
            let {
                firstName,
                lastName,
            } = customer || {};
            
            this.orderEditLogin.classList.toggle('edit-popup--hidden');
            this.orderEditDetails.classList.toggle('edit-popup--hidden');
            
            let productTemplate = document.querySelector('.edit-popup__product--template');
            
            let shippingInputFirstName = document.querySelector('.edit-popup__input[name="first"]');
            let shippingInputLastName = document.querySelector('.edit-popup__input[name="last"]');
            let shippingInputAddress = document.querySelector('.edit-popup__input[name="address"]');
            let shippingInputCity = document.querySelector('.edit-popup__input[name="suburb"]');
            let shippingInputState = document.querySelector('.edit-popup__input[name="state"]');
            let shippingInputCountry = document.querySelector('.edit-popup__input[name="country"]');
            let shippingInputPhone = document.querySelector('.edit-popup__input[name="shipping-phone"]');
            let shippingInputZip = document.querySelector('.edit-popup__input[name="postcode"]');
            
            let deliveryNotes = document.querySelector('.edit-popup__textarea[name="note"]');
            
            let emailInput = document.querySelector('.edit-popup__input[name="email"]');
            let phoneInput = document.querySelector('.edit-popup__input[name="phone"]');
            
            emailInput.value = email;
            phoneInput.value = phone;
            
            shippingInputFirstName.value = firstName;
            shippingInputLastName.value = lastName;
            
            shippingInputAddress.value = address1 + (!!address2 ? ' ' + address2 : '');
            shippingInputCity.value = city;
            shippingInputCountry.value = country;
            shippingInputPhone.value = phone;
            shippingInputState.value = province;
            shippingInputZip.value = zip;
            
            deliveryNotes.value = note;
            
            let productsContainer = document.querySelector('.edit-popup__card-quantity .edit-popup__card-content');
            
            lineItems.forEach(item => {
                let productHtml = productTemplate.innerHTML;
                let product = document.createElement('div');
                product.innerHTML = productHtml;
                
                product.classList.remove('edit-popup__product--template');
                product.classList.add('edit-popup__product');
                
                let itemImage = item.product.media.edges.find(edge => edge.node.image.altText.indexOf('cart-img') > -1);
                if (!itemImage) {
                    itemImage = ((item.variant.image || {}).url || (item.product.featuredImage || {}).url);
                } else {
                    itemImage = itemImage.node.image.originalSrc;
                }

                if (!itemImage) {
                    itemImage = item.product.media.edges[0].node.image.originalSrc;
                }
                
                product.querySelector('.edit-popup__product-title').innerText = item.variant.displayName.replace(' - Default Title', '');
                product.querySelector('.edit-popup__product-image').src = itemImage
                product.querySelector('.edit-popup__product-quantity-number').innerText = item.currentQuantity;
                product.querySelector('.edit-popup__product-price').innerHTML = formatMoneyHtmlLowerCurrency(item.variant.price);
                product.querySelector('.edit-popup__product-subtotal').innerHTML = formatMoneyHtmlLowerCurrency(item.variant.price * item.currentQuantity);
                
                productsContainer.appendChild(product);
                
                let quantityPlus = product.querySelector('.edit-popup__product-quantity-button--plus');
                let quantityMinus = product.querySelector('.edit-popup__product-quantity-button--minus');
                let removeButton = product.querySelector('.edit-popup__product-remove');
                
                quantityPlus.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.id === item.id);

                    lineItem.currentQuantity++;
                    lineItem.updated = true;
                    product.querySelector('.edit-popup__product-quantity-number').innerText = lineItem.currentQuantity;
                    product.querySelector('.edit-popup__product-subtotal').innerHTML = formatMoneyHtmlLowerCurrency(item.variant.price * lineItem.currentQuantity);
                    this.handleOrderChange();
                });
                
                quantityMinus.addEventListener('click', () => {
                    if (item.currentQuantity > 1) {
                        let lineItem = this.order.lineItems.find(lineItem => lineItem.id === item.id);
                        
                        lineItem.currentQuantity--;
                        lineItem.updated = true;
                        product.querySelector('.edit-popup__product-quantity-number').innerText = lineItem.currentQuantity;
                        product.querySelector('.edit-popup__product-subtotal').innerHTML = formatMoneyHtmlLowerCurrency(item.variant.price * lineItem.currentQuantity);
                        this.handleOrderChange();
                    }
                });
                
                removeButton.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.id === item.id);
                    lineItem.currentQuantity = 0;
                    lineItem.updated = true;
                    product.remove();
                    this.handleOrderChange();
                    
                    this.orderEditSubmitButton.classList.remove('edit-popup__button--disabled');
                    this.orderEditSubmitButton.removeAttribute('disabled');
                });
                
            });
            
            let addProductsItems = document.querySelectorAll('.edit-popup__card-add .edit-popup__product');
            let hiddenItems = 0;

            addProductsItems.forEach(item => {
                let quantityPlus = item.querySelector('.edit-popup__product-quantity-button--plus');
                let quantityMinus = item.querySelector('.edit-popup__product-quantity-button--minus');
                let quantityDisplay = item.querySelector('.edit-popup__product-quantity-number');
                let quantitySubtotal = item.querySelector('.edit-popup__product-subtotal');
                let productPrice = formatMoneyHtmlLowerCurrency(item.dataset.price / 100);
                let productPriceEl = item.querySelector('.edit-popup__product-price');
                productPriceEl.innerHTML = productPrice;
                
                this.order.lineItems.map(lineItem => {
                    if (lineItem.variant.id.indexOf(item.dataset.variantId) > -1) {
                        item.classList.add('edit-popup--hidden');
                        hiddenItems++;
                    }
                });
                
                quantityPlus.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.variant.id === item.dataset.variantId);

                    if (!lineItem) {
                        lineItem = {
                            new: true,
                            variant: {
                                id: item.dataset.variantId,
                                price: parseFloat(item.dataset.price / 100),
                            },
                            currentQuantity: 1
                        }
                        this.order.lineItems.push(lineItem);
                        quantityDisplay.innerText = 1;
                        quantitySubtotal.innerText = formatMoney(item.dataset.price / 100);
                        this.handleOrderChange();
                    } else {
                        lineItem.currentQuantity++;
                        quantityDisplay.innerText = lineItem.currentQuantity;
                        quantitySubtotal.innerText = formatMoney((item.dataset.price / 100) * lineItem.currentQuantity);
                        this.handleOrderChange();
                    }
                });
                
                quantityMinus.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.variant.id === item.dataset.variantId);
                    if (!!lineItem && lineItem.currentQuantity > 0) {
                        lineItem.currentQuantity--;
                        quantitySubtotal.innerText = formatMoney((item.dataset.price / 100) * lineItem.currentQuantity);
                        item.querySelector('.edit-popup__product-quantity-number').innerText = lineItem.currentQuantity;
                        item.querySelector('.edit-popup__product-subtotal').innerText = formatMoney((item.dataset.price / 100) * lineItem.currentQuantity);
                        this.handleOrderChange();
                    }
                });
            });

            let addProductsItemsContainer = this.popupDescriptionOrder.querySelector('.edit-popup__card-add');

            if (hiddenItems >= addProductsItems.length) {
                addProductsItemsContainer.classList.add('edit-popup--hidden');
            }
            
            let deliveryDateEl = document.querySelector('.edit-popup__card-delivery-info span[data-delivery-date]');
            let deliveryTimeEl = document.querySelector('.edit-popup__card-delivery-info span[data-delivery-time]');
            
            let deliveryDateAttr = ((customAttributes.find(attr => attr.key === 'Delivery-Date') || {}).value || '').replace('/', '-');
            let deliveryTime = (customAttributes.find(attr => attr.key === 'Delivery-Time') || {}).value;
            let deliveryDate = new Date(deliveryDateAttr);

            if (deliveryDate && deliveryTime) {
                deliveryDateEl.innerText = getFormattedDate(deliveryDate);
                deliveryTimeEl.innerText = deliveryTime;
            } else {
                deliveryDateEl.innerText = '';
                deliveryTimeEl.innerText = '';
            }
            
            let oldTotal = document.querySelector('.edit-popup__card-total__row[data-old-total] span:last-of-type');
            let newTotalEl = document.querySelector('.edit-popup__card-total__row[data-new-total] span:last-of-type');
            let differenceEl = document.querySelector('.edit-popup__card-total__row[data-difference] span:last-of-type');
            
            oldTotal.innerText = formatMoney(parseFloat(this.order.currentTotalPriceSet.presentmentMoney.amount));
            newTotalEl.innerText = formatMoney(parseFloat(this.order.currentTotalPriceSet.presentmentMoney.amount));
            
            differenceEl.innerHTML = formatMoneyHtml(0);
            
            this.popupDescriptionOrder.classList.remove('edit-popup--hidden');
            this.loginDescription.classList.add('edit-popup--hidden');
            
            
            let descriptionOrderNumber = this.popupDescriptionOrder.querySelector('p[data-order-number]');
            descriptionOrderNumber.innerText = `${name}`;
            this.orderEditLoginButton.classList.remove('edit-popup__button--loading');
    
            this.date = new Date();
            this.calendarSetup(this.orderEditDetails);
            this.renderMonth();
        } else {

            let {
                lineItems,
                customAttributes,
            } = this.order;
            
            this.orderEditLogin.classList.toggle('edit-popup--hidden');
            this.orderReorderDetails.classList.toggle('edit-popup--hidden');

            let productTemplate = document.querySelector('.edit-popup__product--template');
            let productsContainer = this.orderReorderDetails.querySelector('.edit-popup__card-quantity .edit-popup__card-content');
            
            lineItems.forEach(item => {
                let productHtml = productTemplate.innerHTML;
                let product = document.createElement('div');
                product.innerHTML = productHtml;
                
                product.classList.remove('edit-popup__product--template');
                product.classList.add('edit-popup__product');
                
                let itemImage = item.product.featuredImage.url;
                if (!itemImage) {
                    itemImage = ((item.variant.image || {}).url || item.product.featuredImage.url);
                } else {
                    //itemImage = itemImage.node.image.originalSrc;
                }
                
                product.querySelector('.edit-popup__product-title').innerText = item.variant.displayName.replace(' - Default Title', '');
                product.querySelector('.edit-popup__product-image').src = itemImage
                product.querySelector('.edit-popup__product-quantity-number').innerText = item.currentQuantity;
                product.querySelector('.edit-popup__product-price').innerHTML = formatMoneyHtmlLowerCurrency(item.variant.price);
                product.querySelector('.edit-popup__product-subtotal').innerHTML = formatMoneyHtmlLowerCurrency(item.variant.price * item.currentQuantity);
                
                productsContainer.appendChild(product);
                
                let quantityPlus = product.querySelector('.edit-popup__product-quantity-button--plus');
                let quantityMinus = product.querySelector('.edit-popup__product-quantity-button--minus');
                let removeButton = product.querySelector('.edit-popup__product-remove');
                
                quantityPlus.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.id === item.id);

                    lineItem.currentQuantity++;
                    lineItem.updated = true;
                    product.querySelector('.edit-popup__product-quantity-number').innerText = lineItem.currentQuantity;
                    product.querySelector('.edit-popup__product-subtotal').innerHTML = formatMoneyHtmlLowerCurrency(item.variant.price * lineItem.currentQuantity);
                    this.handleReorderChange();
                });
                
                quantityMinus.addEventListener('click', () => {
                    if (item.currentQuantity > 1) {
                        let lineItem = this.order.lineItems.find(lineItem => lineItem.id === item.id);
                        
                        lineItem.currentQuantity--;
                        lineItem.updated = true;
                        product.querySelector('.edit-popup__product-quantity-number').innerText = lineItem.currentQuantity;
                        product.querySelector('.edit-popup__product-subtotal').innerHTML = formatMoneyHtmlLowerCurrency(item.variant.price * lineItem.currentQuantity);
                        this.handleReorderChange();
                    }
                });
                
                removeButton.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.id === item.id);
                    lineItem.currentQuantity = 0;
                    lineItem.updated = true;
                    product.remove();
                    this.handleReorderChange();
                    
                    this.orderEditSubmitButton.classList.remove('edit-popup__button--disabled');
                    this.orderEditSubmitButton.removeAttribute('disabled');
                });
                
            });
            
            let hiddenItems = 0;
            let addProductsItems = this.orderReorderDetails.querySelectorAll('.edit-popup__card-add .edit-popup__product');
            addProductsItems.forEach(item => {
                let quantityPlus = item.querySelector('.edit-popup__product-quantity-button--plus');
                let quantityMinus = item.querySelector('.edit-popup__product-quantity-button--minus');
                let quantityDisplay = item.querySelector('.edit-popup__product-quantity-number');
                let quantitySubtotal = item.querySelector('.edit-popup__product-subtotal');
                let productPrice = formatMoneyHtmlLowerCurrency(item.dataset.price / 100);
                let productPriceEl = item.querySelector('.edit-popup__product-price');
                productPriceEl.innerHTML = productPrice;
                
                this.order.lineItems.map(lineItem => {
                    if (lineItem.variant.id.indexOf(item.dataset.variantId) > -1) {
                        item.classList.add('edit-popup--hidden');
                        hiddenItems++;
                    }
                });
                
                quantityPlus.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.variant.id === item.dataset.variantId);
                    if (!lineItem) {
                        lineItem = {
                            new: true,
                            variant: {
                                id: item.dataset.variantId,
                                price: parseFloat(item.dataset.price / 100),
                            },
                            currentQuantity: 1
                        }
                        this.order.lineItems.push(lineItem);
                        quantityDisplay.innerText = 1;
                        quantitySubtotal.innerText = formatMoney(item.dataset.price / 100);
                        this.handleReorderChange();
                    } else {
                        lineItem.currentQuantity++;
                        quantityDisplay.innerText = lineItem.currentQuantity;
                        quantitySubtotal.innerText = formatMoney((item.dataset.price / 100) * lineItem.currentQuantity);
                        this.handleReorderChange();
                    }
                });
                
                quantityMinus.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.variant.id === item.dataset.variantId);
                    if (!!lineItem && lineItem.currentQuantity > 0) {
                        lineItem.currentQuantity--;
                        quantitySubtotal.innerText = formatMoney((item.dataset.price / 100) * lineItem.currentQuantity);
                        item.querySelector('.edit-popup__product-quantity-number').innerText = lineItem.currentQuantity;
                        item.querySelector('.edit-popup__product-subtotal').innerText = formatMoney((item.dataset.price / 100) * lineItem.currentQuantity);
                        this.handleReorderChange();
                    }
                });
            });

            let upsellItems = this.orderReorderUpsell.querySelectorAll('.edit-popup__upsell-item');
            upsellItems.forEach(item => {
                let quantityPlus = item.querySelector('.edit-popup__product-quantity-button--plus');
                let quantityMinus = item.querySelector('.edit-popup__product-quantity-button--minus');
                let quantityDisplay = item.querySelector('.edit-popup__product-quantity-number');
                let variantSelect = item.querySelector('.edit-popup__upsell-item__variant');
                let addProductButton = item.querySelector('.edit-popup__button--add-upsell');
                let price = item.querySelector('.edit-popup__upsell-item__price');

                price.innerHTML = formatMoneyHtmlLowerCurrency(item.dataset.price / 100, true);

                let inventory = parseInt(item.dataset.inventory);
                let currentQuantity = parseInt(quantityDisplay.innerText);

                if (currentQuantity == inventory) {
                    quantityPlus.classList.add('edit-popup--invisible');
                }

                quantityPlus.addEventListener('click', () => {
                    let currentQuantity = parseInt(quantityDisplay.innerText);
                    let inventory = parseInt(item.dataset.inventory);

                    if (currentQuantity == inventory) {
                        quantityPlus.classList.add('edit-popup--invisible');
                    }
                    
                    if (currentQuantity < inventory) {
                        currentQuantity++;
                    } else {
                        currentQuantity = inventory;
                    }

                    quantityDisplay.innerText = currentQuantity;
                });

                quantityMinus.addEventListener('click', () => {
                    let currentQuantity = parseInt(quantityDisplay.innerText);

                    quantityPlus.classList.remove('edit-popup--invisible');

                    if (currentQuantity > 1) {
                        currentQuantity--;
                    } else {
                        currentQuantity = 1;
                    }

                    quantityDisplay.innerText = currentQuantity;
                });

                variantSelect.addEventListener('change', (e) => {
                    let selectedVariant = e.target.value;
                    let currentOption = e.target.options[e.target.selectedIndex];
                    let variantPrice = currentOption.dataset.price;

                    item.dataset.variant = selectedVariant;
                    item.dataset.price = variantPrice;
                    item.dataset.inventory = currentOption.dataset.inventory;

                    let currentQuantity = parseInt(quantityDisplay.innerText);
                    if (currentQuantity > parseInt(item.dataset.inventory)) {
                        currentQuantity = parseInt(item.dataset.inventory);
                        quantityDisplay.innerText = currentQuantity;

                    }

                    if (currentQuantity == parseInt(item.dataset.inventory)) {
                        quantityPlus.classList.add('edit-popup--invisible');
                    } else {
                        quantityPlus.classList.remove('edit-popup--invisible');
                    }
                });

                addProductButton.addEventListener('click', () => {
                    let variantId = item.dataset.variant;
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.variant.id.indexOf(variantId) > -1);
                    let currentQuantity = parseInt(quantityDisplay.innerText);
                    let variantPrice = parseFloat(item.dataset.price / 100);
                    let productData = JSON.parse(item.querySelector('script[type="application/json"]').innerHTML);

                    if (!lineItem) {
                        lineItem = {
                            upsellNew: true,
                            variant: {
                                id: variantId,
                                price: variantPrice,
                            },
                            data: {
                                ...productData
                            },
                            currentQuantity
                        }
                        this.order.lineItems.push(lineItem);
                        this.handleReorderChange();
                    } else {
                        lineItem.currentQuantity += currentQuantity;
                        this.handleReorderChange();
                    }
                });

            });

            let upsellContainer = this.orderReorderUpsell.querySelector('.edit-popup__upsells');
            // add drag to scroll horizontally logic
            let isDown = false;
            let startX;
            let scrollLeft;

            upsellContainer.addEventListener('mousedown', (e) => {
                isDown = true;
                startX = e.pageX - upsellContainer.offsetLeft;
                scrollLeft = upsellContainer.scrollLeft;
            });

            upsellContainer.addEventListener('mouseleave', () => {
                isDown = false;
            });

            upsellContainer.addEventListener('mouseup', () => {
                isDown = false;
            });

            upsellContainer.addEventListener('mousemove', (e) => {
                if (!isDown) return;

                e.preventDefault();
                const x = e.pageX - upsellContainer.offsetLeft;
                const walk = (x - startX) * 3; //scroll-fast
                upsellContainer.scrollLeft = scrollLeft - walk;
            });

            let addedProductsContainer = document.querySelector('.edit-popup__card-added');
            let addedProducts = addedProductsContainer.querySelectorAll('.edit-popup__product');

            addedProducts.forEach(relatedAddedProduct => {
                let relatedAddedProductQuantity = relatedAddedProduct.querySelector('.edit-popup__product-quantity-number');
                let relatedAddedProductQuantityMinus = relatedAddedProduct.querySelector('.edit-popup__product-quantity-button--minus');
                let relatedAddedProductQuantityPlus = relatedAddedProduct.querySelector('.edit-popup__product-quantity-button--plus');
                let relatedAddedProductRemove = relatedAddedProduct.querySelector('.edit-popup__product-remove');
                let relatedAddedProductSubtotal = relatedAddedProduct.querySelector('.edit-popup__product-subtotal');

                relatedAddedProductQuantityMinus.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.variant.id.indexOf(relatedAddedProduct.dataset.variantId) > -1);
                    if (!!lineItem && lineItem.currentQuantity > 0) {
                        lineItem.currentQuantity--;
                        relatedAddedProductQuantity.innerText = lineItem.currentQuantity;
                        this.handleReorderChange();
                    }
                });

                relatedAddedProductQuantityPlus.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.variant.id.indexOf(relatedAddedProduct.dataset.variantId) > -1);
                    if (lineItem) {
                        lineItem.currentQuantity++;
                        relatedAddedProductQuantity.innerText = lineItem.currentQuantity;
                        this.handleReorderChange();
                    }
                });

                relatedAddedProductRemove.addEventListener('click', () => {
                    let lineItem = this.order.lineItems.find(lineItem => lineItem.variant.id.indexOf(relatedAddedProduct.dataset.variantId) > -1);
                    lineItem.currentQuantity = 0;
                    this.handleReorderChange();
                });
            });

            let addProductsItemsContainer = this.orderReorderDetails.querySelector('.edit-popup__card-add');

            if (hiddenItems >= addProductsItems.length) {
                addProductsItemsContainer.classList.add('edit-popup--hidden');
            }
            
            let deliveryDateEl = this.orderReorderDetails.querySelector('.edit-popup__card-delivery-info span[data-delivery-date]');
            let deliveryTimeEl = this.orderReorderDetails.querySelector('.edit-popup__card-delivery-info span[data-delivery-time]');
            
            let deliveryDateAttr = ((customAttributes.find(attr => attr.key === 'Delivery-Date') || {}).value || '').replace('/', '-');
            let deliveryTime = (customAttributes.find(attr => attr.key === 'Delivery-Time') || {}).value;
            let deliveryDate = new Date(deliveryDateAttr);
            
            //if (deliveryDate) deliveryDateEl.innerText = getFormattedDate(deliveryDate);
            //if (deliveryTime) deliveryTimeEl.innerText = deliveryTime;
            
            let subtotalEl = this.orderReorderDetails.querySelector('.edit-popup__card-total__row[data-old-total] span:last-of-type');
            let shippingEl = this.orderReorderDetails.querySelector('.edit-popup__card-total__row[data-new-total] span:last-of-type');
            let totalEl = this.orderReorderDetails.querySelector('.edit-popup__card-total__row[data-difference] span:last-of-type');

            let subtotalElUpsell = this.orderReorderUpsell.querySelector('.edit-popup__card-total__row[data-old-total] span:last-of-type');
            let shippingElUpsell = this.orderReorderUpsell.querySelector('.edit-popup__card-total__row[data-new-total] span:last-of-type');
            let totalElUpsell = this.orderReorderUpsell.querySelector('.edit-popup__card-total__row[data-difference] span:last-of-type');
            
            let subtotalAmount = this.order.lineItems.reduce((acc, item) => {
                return acc + item.currentQuantity * parseFloat(item.variant.price);
            }, 0);

            subtotalEl.innerText = formatMoney(parseFloat(subtotalAmount));
            shippingEl.innerText = formatMoney(parseFloat(this.order.totalShippingPriceSet.presentmentMoney.amount));

            subtotalElUpsell.innerText = formatMoney(parseFloat(subtotalAmount));
            shippingElUpsell.innerText = formatMoney(parseFloat(this.order.totalShippingPriceSet.presentmentMoney.amount));
            
            totalEl.innerHTML = formatMoneyHtml(parseFloat(subtotalAmount) + parseFloat(this.order.totalShippingPriceSet.presentmentMoney.amount));
            totalElUpsell.innerHTML = formatMoneyHtml(parseFloat(subtotalAmount) + parseFloat(this.order.totalShippingPriceSet.presentmentMoney.amount));

            //this.popupDescriptionOrder.classList.remove('edit-popup--hidden');
            this.loginDescription.classList.add('edit-popup--hidden');
            this.calendarSetup(this.orderReorderDetails);

            this.date = new Date();
            this.renderMonth();
            
        }

    }
    
    handleOrderChange () {
        let oldTotalAmount = parseFloat(this.order.currentTotalPriceSet.presentmentMoney.amount);
        let newTotal = this.order.lineItems.reduce((acc, item) => {
            return acc + item.currentQuantity * parseFloat(item.variant.price);
        }, 0);
        newTotal += (!this.order.shippingLine ? 0 : parseFloat((this.order.shippingLine || {}).price || 0));
        
        let oldTotal = document.querySelector('.edit-popup__card-total__row[data-old-total] span:last-of-type');
        let newTotalEl = document.querySelector('.edit-popup__card-total__row[data-new-total] span:last-of-type');
        let differenceEl = document.querySelector('.edit-popup__card-total__row[data-difference] span:last-of-type');
        
        oldTotal.innerText = formatMoney(parseFloat(oldTotalAmount));
        
        newTotalEl.innerText = formatMoney(newTotal);
        
        let difference = newTotal - oldTotalAmount;
        differenceEl.innerHTML = formatMoneyHtml(difference);
        
        if (difference < 0) {
            differenceEl.parentNode.classList.add('edit-popup__card-total__row--refund');
        } else {
            differenceEl.parentNode.classList.remove('edit-popup__card-total__row--refund');
        }
        
        let totalEl = document.querySelector('.edit-popup__card-total');
        totalEl.classList.remove('edit-popup--hidden');
        this.orderEditSubmitButton.classList.remove('edit-popup__button--disabled');
        this.orderEditSubmitButton.removeAttribute('disabled');
        
        let addProductsItemsContainer = document.querySelector('.edit-popup__card-add');
        let addProductsItems = addProductsItemsContainer.querySelectorAll('.edit-popup__product');
        let itemsVisible = 0;
        
        addProductsItems.forEach(item => {
            this.order.lineItems.map(lineItem => {
                if (!lineItem.new && lineItem.variant.id.indexOf(item.dataset.variantId) > -1) {
                    if (lineItem.currentQuantity > 0) {
                        item.classList.add('edit-popup--hidden');
                    } else {
                        item.classList.remove('edit-popup--hidden');
                    }
                }
            });
            
            if (!item.classList.contains('edit-popup--hidden')) {
                itemsVisible++;
            }
        });

        if (itemsVisible === 0) {
            addProductsItemsContainer.classList.add('edit-popup--hidden');
        } else {
            addProductsItemsContainer.classList.remove('edit-popup--hidden');
        }


        let dateEl = this.orderEditDetails.querySelector('.edit-popup__card-delivery-info span[data-delivery-date]');
        let timeEl = this.orderEditDetails.querySelector('.edit-popup__card-delivery-info span[data-delivery-time]');
        
        let deliveryDateAttr = (`${(this.order.customAttributes.find(attr => attr.key === 'Delivery-Date') || {}).value}` || '').replace('/', '-');
        let deliveryTime = (this.order.customAttributes.find(attr => attr.key === 'Delivery-Time') || {}).value;
        let deliveryDate = new Date(deliveryDateAttr);

        if (deliveryDate) dateEl.innerText = getFormattedDate(deliveryDate);
        if (deliveryTime) timeEl.innerText = deliveryTime;
    }

    handleReorderChange () {
        let newTotal = this.order.lineItems.reduce((acc, item) => {
            return acc + item.currentQuantity * parseFloat(item.variant.price);
        }, 0);
        
        let subtotalEl = this.orderReorderDetails.querySelector('.edit-popup__card-total__row[data-old-total] span:last-of-type');
        let totalEl = this.orderReorderDetails.querySelector('.edit-popup__card-total__row[data-difference] span:last-of-type');
        let subtotalElUpsell = this.orderReorderUpsell.querySelector('.edit-popup__card-total__row[data-old-total] span:last-of-type');
        let totalElUpsell = this.orderReorderUpsell.querySelector('.edit-popup__card-total__row[data-difference] span:last-of-type');
        
        subtotalEl.innerText = formatMoney(newTotal);
        subtotalElUpsell.innerText = formatMoney(newTotal);

        newTotal += parseFloat(this.order.totalShippingPriceSet.presentmentMoney.amount);
        
        totalEl.innerHTML = formatMoneyHtml(newTotal);
        totalElUpsell.innerHTML = formatMoneyHtml(newTotal);
        
        let addProductsItemsContainer = this.orderReorderDetails.querySelector('.edit-popup__card-add');
        let addProductsItems = addProductsItemsContainer.querySelectorAll('.edit-popup__product');
        let itemsVisible = 0;
        
        addProductsItems.forEach(item => {
            this.order.lineItems.map(lineItem => {
                if (!lineItem.new && lineItem.variant.id.indexOf(item.dataset.variantId) > -1) {
                    if (lineItem.currentQuantity > 0) {
                        item.classList.add('edit-popup--hidden');
                    } else {
                        item.classList.remove('edit-popup--hidden');
                    }
                }
            });
            
            if (!item.classList.contains('edit-popup--hidden')) {
                itemsVisible++;
            }
        });

        let upsellItems = this.order.lineItems.filter(item => item.upsellNew && item.currentQuantity > 0);
        let addedProductsContainer = document.querySelector('.edit-popup__card-added');

        if (upsellItems.length > 0) {
            addedProductsContainer.classList.remove('edit-popup--hidden');

            let addedProductsItems = addedProductsContainer.querySelectorAll('.edit-popup__product');
            addedProductsItems.forEach(item => {
                item.classList.add('edit-popup--hidden');
            });
            upsellItems.forEach(item => {
                let addedProduct = addedProductsContainer.querySelector(`.edit-popup__product[data-product-id="${item.data.id}"]`);
                addedProduct.classList.remove('edit-popup--hidden');

                let { data } = item;
                let variantData = {...data.variants.find(variant => variant.id == item.variant.id)};
                variantData.price = parseFloat(variantData.price) / 100;

                addedProduct.querySelector('.edit-popup__product-quantity-number').innerText = item.currentQuantity;
                addedProduct.querySelector('.edit-popup__product-name .edit-popup__product-title').innerText = data.title;
                addedProduct.querySelector('.edit-popup__product-subtotal').innerText = formatMoney(item.currentQuantity * variantData.price);
                addedProduct.querySelector('.edit-popup__product-subtitle').innerText = 'Size: ' + variantData.title.replace(' - Default Title', '');
                addedProduct.querySelector('.edit-popup__product-image').src = data.image;
                addedProduct.querySelector('.edit-popup__product-price').innerHTML = formatMoneyHtmlLowerCurrency(variantData.price);
            });
        } else {
            addedProductsContainer.classList.add('edit-popup--hidden');
        }   
        
        if (itemsVisible === 0) {
            addProductsItemsContainer.classList.add('edit-popup--hidden');
        } else {
            addProductsItemsContainer.classList.remove('edit-popup--hidden');
        }


        let dateEl = this.orderReorderDetails.querySelector('.edit-popup__card-delivery-info span[data-delivery-date]');
        let timeEl = this.orderReorderDetails.querySelector('.edit-popup__card-delivery-info span[data-delivery-time]');
        
        //let deliveryDateAttr = ((this.order.customAttributes.find(attr => attr.key === 'Delivery-Date') || {}).value || '').replace('/', '-');
        //let deliveryTime = (this.order.customAttributes.find(attr => attr.key === 'Delivery-Time') || {}).value;
        //let deliveryDate = new Date(deliveryDateAttr);

        //if (deliveryDate) dateEl.innerText = getFormattedDate(deliveryDate);
        //if (deliveryTime) timeEl.innerText = deliveryTime;
    }
    
    async handleOrderUpdate () {
        
        this.orderEditSubmitButton.classList.add('edit-popup__button--loading');
        let updatedItems = this.order.lineItems.filter(item => !item.new && item.updated).map(item => {
            return {
                id: item.id,
                quantity: item.currentQuantity
            }
        });
        
        let newItems = this.order.lineItems.filter(item => item.new).map(item => {
            return {
                id: item.variant.id,
                quantity: item.currentQuantity
            }
        });

        let orderUpdateResponse = await fetch('https://billybubbles.com/apps/order-api', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'update',
                orderId: this.order.id,
                updatedLineItems: updatedItems,
                newLineItems: newItems,
                orderNote: this.order.note,
                email: this.order.email,
                phone: this.order.phone,
                customAttributes: this.order.customAttributes.map(attr => {
                    if (attr.key == "Delivery-Date") {
                        // check if number after last slash is a single digit, add a 0 if so
                        let dateParts = attr.value.split('/');
                        if (dateParts[2].length === 1) {
                            dateParts[2] = `0${dateParts[2]}`;
                        }
                        attr.value = dateParts.join('/');
                    }

                    attr.value = `${attr.value}`;

                    return attr;
                })
            })
        });
        let orderUpdate = await orderUpdateResponse.json();
        let paymentCollectionUrl = orderUpdate.order.paymentCollectionDetails.additionalPaymentCollectionUrl;
        let shouldRedirect = orderUpdate.redirect;
        if (shouldRedirect) {
            window.location.href = paymentCollectionUrl;
        } else {
            this.order = {
                ...this.order,
                ...orderUpdate.order
            }
            
            //this.order.lineItems = this.order.lineItems.edges.map(item => item.node);
            this.handleUpdateConfirmation();
        }
        this.orderEditSubmitButton.classList.remove('edit-popup__button--loading');
    }
    
    handleUpdateConfirmation () {
        
        let {
            email,
            phone,
            id,
            lineItems,
            note,
            shippingAddress,
            shippingLine,
            customAttributes,
            currentTotalPriceSet
        } = this.order;
        
        let productTemplate = document.querySelector('.edit-popup__product--template');
        let productsContainer = document.querySelector('.edit-popup__updated-items');
        
        lineItems.map(item => {
            let productHtml = productTemplate.innerHTML;
            let product = document.createElement('div');
            product.innerHTML = productHtml;
            
            product.classList.remove('edit-popup__product--template');
            product.classList.add('edit-popup__product');
            
            let itemImage = item.product.media.edges.find(edge => edge.node.image.altText.indexOf('cart-img') > -1);
            if (!itemImage) {
                itemImage = ((item.variant.image || {}).url || item.product.featuredImage.url);
            } else {
                itemImage = itemImage.node.image.originalSrc;
            }
            
            product.querySelector('.edit-popup__product-title').innerText = item.variant.displayName.replace(' - Default Title', '');
            product.querySelector('.edit-popup__product-image').src = itemImage
            product.querySelector('.edit-popup__product-quantity-number').innerText = item.currentQuantity;
            product.querySelector('.edit-popup__product-price').innerHTML = formatMoneyHtmlLowerCurrency(item.variant.price);
            product.querySelector('.edit-popup__product-subtotal').innerText = formatMoney(item.variant.price * item.currentQuantity);
            
            productsContainer.appendChild(product);
            
        });
        
        let subtotalEl = document.querySelector('.edit-popup__updated-total .edit-popup__card-total__row[data-subtotal] span:last-of-type');
        let shippingEl = document.querySelector('.edit-popup__updated-total .edit-popup__card-total__row[data-shipping] span:last-of-type');
        let totalEl = document.querySelector('.edit-popup__updated-total .edit-popup__card-total__row[data-total] span:last-of-type');
        
        subtotalEl.innerHTML = formatMoneyHtmlLowerCurrency(parseFloat(currentTotalPriceSet.presentmentMoney.amount));
        shippingEl.innerText = formatMoney(parseFloat((shippingLine || {}).price || 0));
        totalEl.innerHTML = formatMoneyHtmlLowerCurrency(parseFloat(currentTotalPriceSet.presentmentMoney.amount) + parseFloat((shippingLine || {}).price || 0));
        
        let addressEl = document.querySelector('.edit-popup__updated-address span:last-of-type');
        let noteEl = document.querySelector('.edit-popup__updated-notes span:last-of-type');
        
        let emailEl = document.querySelector('.edit-popup__updated-contact__row[data-email] span:last-of-type');
        let phoneEl = document.querySelector('.edit-popup__updated-contact__row[data-phone] span:last-of-type');
        let dateEl = document.querySelector('.edit-popup__updated-time[data-date] span:last-of-type');
        let timeEl = document.querySelector('.edit-popup__updated-time[data-time] span:last-of-type');
        
        let deliveryDateAttr = ((customAttributes.find(attr => attr.key === 'Delivery-Date') || {}).value || '').replace('/', '-');
        let deliveryTime = (customAttributes.find(attr => attr.key === 'Delivery-Time') || {}).value;
        let deliveryDate = new Date(deliveryDateAttr);

        if (!deliveryDateAttr) {
            let deliveryInput = this.querySelector('.edit-popup__card-delivery input');
            if (deliveryInput) deliveryInput.classList.add('edit-popup--hidden');
        }
        
        dateEl.innerText = getFormattedDate(deliveryDate);
        timeEl.innerText = deliveryTime;
        
        emailEl.innerText = email;
        phoneEl.innerText = phone;
        addressEl.innerHTML = `${shippingAddress.address1 || ''} ${shippingAddress.address2 || ''} <br /> ${shippingAddress.city || ''} ${shippingAddress.province || ''} ${shippingAddress.zip || ''} <br /> ${shippingAddress.phone || phone || ''}`;
        noteEl.innerText = note;
        
        this.popupUpdatedOrder.classList.toggle('edit-popup--hidden');
        this.orderEditDetails.classList.add('edit-popup--hidden');
        
        this.popupDescriptionOrderUpdated.classList.remove('edit-popup--hidden');
        this.popupDescriptionOrder.classList.add('edit-popup--hidden');
        
    }
    
    handleClose (e) {
        
        this.classList.toggle('edit-popup--active');

        if (e.closest('.edit-popup__updated-order')) {
            this.orderEditLogin.classList.remove('edit-popup--hidden');
            this.orderEditDetails.classList.add('edit-popup--hidden');
            this.popupUpdatedOrder.classList.add('edit-popup--hidden');
            this.orderErrorPage.classList.add('edit-popup--hidden');
            this.orderEditLinkPage.classList.add('edit-popup--hidden');
        }

        if (!this.classList.contains('edit-popup--active')) {
            this.orderEditLogin.classList.remove('edit-popup--hidden');
            this.orderReorderDetails.classList.add('edit-popup--hidden');
            this.orderReorderUpsell.classList.add('edit-popup--hidden');
        }
    }
}

customElements.define('custom-order-edit', CustomOrderEdit);


const listenToCart = (callback) => {
    const ShopifyCartURLs = [
        "add",
        "add.js",
        "change",
        "change.js",
        "update",
        "update.js",
    ];
  
    function isShopifyCartURL(url) {
      if (!url) return false;
      const path = url.split("/").pop().split("?")[0];
      return ShopifyCartURLs.includes(`${path}`);
    }
  
    function dispatchEvent(url, detail) {
      callback(url, detail)
    }
  
    function fetchOverride() {
      if (!window.fetch || typeof window.fetch !== "function") return;
      const originalFetch = window.fetch;
      window.fetch = function () {
        const response = originalFetch.apply(this, arguments);
        if (isShopifyCartURL(arguments[0])) {
          response.then((res) => {
            res
              .clone()
              .json()
              .then((data) => dispatchEvent(res.url, data));
          });
        }
  
        return response;
      };
    }
  
    function XHROverride() {
      if (!window.XMLHttpRequest) return;
  
      const originalOpen = window.XMLHttpRequest.prototype.open;
      window.XMLHttpRequest.prototype.open = function () {
        const url = arguments[1];
        this.addEventListener("load", function () {
          if (isShopifyCartURL(url)) {
            dispatchEvent(url, this.response);
          }
        });
        return originalOpen.apply(this, arguments);
      };
    }
  
    XHROverride();
    fetchOverride();
};

document.addEventListener('DOMContentLoaded', () => {
    let hiddenProducts = window.upsellItems.map(item => item.id);
    listenToCart((url, data) => {
        if (url.indexOf('add') > -1 && hiddenProducts.includes(data.product_id)) {
            console.log(data);
            
            fetch('/cart/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: `updates[${data.variant_id}]=0`
            }).then(response => {
                return response.json();
            }).then(response => {
                console.log(response);
            });
        } else if (url.indexOf('update') > -1 || url.indexOf('change') > -1) {
            console.log(data);
            
            let cartItems = data.items;
            let updatedItems = cartItems.filter(item => hiddenProducts.includes(item.product_id));
            let updates = {};

            updatedItems.map(item => {
                updates[item.variant_id] = 0;
            });

            fetch('/cart/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates
                })
            }).then(response => {
                return response.json();
            }).then(response => {
                console.log(response);
            });
        }
    });
});